module.exports = __webpack_public_path__ + "static/media/img_Inscription_free1.b3dbefb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_Inscription_free1.png
// module id = 980
// module chunks = 0